const OrderLineItemsProductView = ({ lineItems, showWarnings }) => {
  let hasItemsNotInStock = false;

  if (showWarnings) {
    lineItems.forEach((i) => {
      if (!i.node.stock_product) {
        hasItemsNotInStock = true;
        return;
      }
    });
  }

  return (
    <div>
      <div className="flex flex-wrap">
        {lineItems.map(({ node }, index) => (
          <span
            key={index}
            className={`mr-1
            ${
              showWarnings ? (node.stock_product ? "" : "text-red-600") : null
            }`}
          >
            {node.sku}({node.quantity})
          </span>
        ))}
      </div>

      {hasItemsNotInStock ? (
        <div className="text-red-600 font-semibold mt-1">
          ⚠️ There are skus not in warehouse.
        </div>
      ) : null}
    </div>
  );
};

export default OrderLineItemsProductView;
